"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UniV2LikeSubgraphCache = void 0;
const shared_models_1 = require("@railgun-community/shared-models");
const UNI_V2_ETH_PAIRS_json_1 = __importDefault(require("./UNI-V2-ETH-PAIRS.json"));
const SUSHI_V2_ETH_PAIRS_json_1 = __importDefault(require("./SUSHI-V2-ETH-PAIRS.json"));
const SUSHI_V2_POLYGON_PAIRS_json_1 = __importDefault(require("./SUSHI-V2-POLYGON-PAIRS.json"));
const SUSHI_V2_BSC_PAIRS_json_1 = __importDefault(require("./SUSHI-V2-BSC-PAIRS.json"));
const SUSHI_V2_ARBITRUM_PAIRS_json_1 = __importDefault(require("./SUSHI-V2-ARBITRUM-PAIRS.json"));
const PANCAKE_V2_BSC_PAIRS_json_1 = __importDefault(require("./PANCAKE-V2-BSC-PAIRS.json"));
const QUICK_V2_POLYGON_PAIRS_json_1 = __importDefault(require("./QUICK-V2-POLYGON-PAIRS.json"));
const utils_1 = require("../../utils");
const models_1 = require("../../models");
const uni_v2_like_sdk_1 = require("../../api/uni-v2-like/uni-v2-like-sdk");
const lp_pair_1 = require("../../utils/lp-pair");
class UniV2LikeSubgraphCache {
    static async getCachedPairsForTokenAddresses(provider, networkName, tokenAddresses) {
        const lpCachedList = UniV2LikeSubgraphCache.getCachedLPListForNetwork(networkName);
        const filtered = lpCachedList.filter(({ id, token0, token1 }) => {
            return (((0, utils_1.compareTokenAddresses)(tokenAddresses, token0.id) &&
                (0, utils_1.compareTokenAddresses)(tokenAddresses, token1.id)) ||
                (0, utils_1.compareTokenAddresses)(tokenAddresses, id));
        });
        return Promise.all(filtered.map(async ({ id, uniswapV2Fork, token0, token1 }) => {
            const erc20InfoA = {
                tokenAddress: token0.id,
                decimals: BigInt(token0.decimals),
            };
            const erc20InfoB = {
                tokenAddress: token1.id,
                decimals: BigInt(token1.decimals),
            };
            const rateWith18Decimals = await uni_v2_like_sdk_1.UniV2LikeSDK.getPairRateWith18Decimals(uniswapV2Fork, networkName, provider, erc20InfoA, erc20InfoB);
            const pairData = {
                name: (0, lp_pair_1.getLPPoolName)(uniswapV2Fork, token0.symbol, token1.symbol),
                uniswapV2Fork: uniswapV2Fork,
                tokenAddressA: erc20InfoA.tokenAddress,
                tokenSymbolA: token0.symbol,
                tokenDecimalsA: erc20InfoA.decimals,
                tokenAddressB: erc20InfoB.tokenAddress,
                tokenDecimalsB: erc20InfoB.decimals,
                tokenSymbolB: token1.symbol,
                pairAddress: id,
                pairTokenName: (0, lp_pair_1.getLPPairTokenName)(uniswapV2Fork, token0.symbol, token1.symbol),
                pairTokenSymbol: (0, lp_pair_1.getLPPairTokenSymbol)(token0.symbol, token1.symbol),
                pairTokenDecimals: (0, lp_pair_1.getPairTokenDecimals)(),
                rateWith18Decimals,
            };
            return pairData;
        }));
    }
    static getCachedLPListForNetwork(networkName) {
        switch (networkName) {
            case shared_models_1.NetworkName.Ethereum:
                return [
                    ...UniV2LikeSubgraphCache.mapItemsToFork(UNI_V2_ETH_PAIRS_json_1.default, models_1.UniswapV2Fork.Uniswap),
                    ...UniV2LikeSubgraphCache.mapItemsToFork(SUSHI_V2_ETH_PAIRS_json_1.default, models_1.UniswapV2Fork.SushiSwap),
                ];
            case shared_models_1.NetworkName.BNBChain:
                return [
                    ...UniV2LikeSubgraphCache.mapItemsToFork(SUSHI_V2_BSC_PAIRS_json_1.default, models_1.UniswapV2Fork.SushiSwap),
                    ...UniV2LikeSubgraphCache.mapItemsToFork(PANCAKE_V2_BSC_PAIRS_json_1.default, models_1.UniswapV2Fork.PancakeSwap),
                ];
            case shared_models_1.NetworkName.Polygon:
                return [
                    ...UniV2LikeSubgraphCache.mapItemsToFork(SUSHI_V2_POLYGON_PAIRS_json_1.default, models_1.UniswapV2Fork.SushiSwap),
                    ...UniV2LikeSubgraphCache.mapItemsToFork(QUICK_V2_POLYGON_PAIRS_json_1.default, models_1.UniswapV2Fork.Quickswap),
                ];
            case shared_models_1.NetworkName.Arbitrum:
                return UniV2LikeSubgraphCache.mapItemsToFork(SUSHI_V2_ARBITRUM_PAIRS_json_1.default, models_1.UniswapV2Fork.SushiSwap);
            case shared_models_1.NetworkName.EthereumSepolia:
            case shared_models_1.NetworkName.Hardhat:
            case shared_models_1.NetworkName.PolygonAmoy:
            case shared_models_1.NetworkName.EthereumRopsten_DEPRECATED:
            case shared_models_1.NetworkName.EthereumGoerli_DEPRECATED:
            case shared_models_1.NetworkName.ArbitrumGoerli_DEPRECATED:
            case shared_models_1.NetworkName.PolygonMumbai_DEPRECATED:
                return [];
        }
    }
    static mapItemsToFork(items, uniswapV2Fork) {
        return items.map(item => ({
            ...item,
            uniswapV2Fork,
        }));
    }
}
exports.UniV2LikeSubgraphCache = UniV2LikeSubgraphCache;
